(function() {
  'use strict';

  angular.module('ringbaPortal').component('selectTarget', {
    bindings: {
      routeContainerType: '@', // either campaign or callplan
      routeContainer: '<',
      routeType: '<',
      onUpdate: '&'
    },
    controller: SelectTargetController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/select-target.view.html'
  });

  function SelectTargetController(
    $scope,
    $uibModal,
    $filter,
    accountsService,
    callPlanService,
    callRouteService,
    campaignServiceNew,
    infoService,
    targetService,
    isMobileDevice,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.conversionSettings = null;
    vm.conversionSettingsMap = {};
    vm.regex_digits_optional = new RegExp('\\d*');
    vm.currentTab = 'targets';
    vm.hasTargetGroups = false; // For campaigns target groups warning message when Pass Through is enabled

    vm.isPingTree = isPingTree;


    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.deleteRoute = deleteRoute;
    vm.updateCallRoute = updateCallRoute;
    vm.editCallRoute = editCallRoute;
    vm.cancelModal = cancelModal;
    vm.createUpdateRoute = createUpdateRoute;
    vm.displayConversionTypeName = displayConversionTypeName;
    vm.displayConversionTypeDetails = displayConversionTypeDetails;
    vm.activateRouteActions = activateRouteActions;
    vm.isRPC = false;

    vm.conversionCallLengthEventMap = {
      OnIncomingCall: $filter('translate')('ROUTING_CONVERSION_CALL_INCOMING'),
      OnDial: $filter('translate')('ROUTING_CONVERSION_CALL_DIAL'),
      OnConnectedCall: $filter('translate')('ROUTING_CONVERSION_CALL_CONNECT')
    };

    function onInit() {
      vm.isMobileView = isMobileDevice;
      _loadIsRPC();
      _loadConversionSettings();
      _checkTargetGroups();
    }

    function onChanges(changesObj) {
      _loadIsRPC();
      if (changesObj.routeContainer) {
        _updateRouteStatus();
        _checkTargetGroups();
      }
    }

    function isPingTree(callRoute){

      if(typeof callRoute === 'undefined'){
        return false;
      }
      if(typeof callRoute.callPingTree !== 'undefined' ){
        return true;
      }
      return false;
    }

    function deleteRoute(callRouteId) {
      _deleteRoute(callRouteId)
        .then(function () {
          toaster.pop('success', $filter('translate')('TARGET_ROUTE_DELETE_SUCCESS'));
          vm.onUpdate({
            routeContainer: vm.routeContainer
          });
        })
        .catch(utils.errorHandler);
    }

    /* Used in the number-stepper directive */
    function updateCallRoute(callRoute) {
      callRouteService.updateCallRoute(accountsService.currentAccountId, callRoute)
        .catch(utils.errorHandler);
    }

    function displayConversionTypeName(conversionType) {
      if(conversionType === 'pingTree'){
        return 'Ring Tree';
      }
      if (Object.hasOwn(vm.conversionSettingsMap, conversionType)) {
        return vm.conversionSettingsMap[conversionType].name;
      } else {
        return conversionType;
      }
    }

    function displayConversionTypeDetails(conversionSettings) {
      const callLength = $filter('secondsToTextFormat')(conversionSettings.conversionArgs.callLengthInSeconds) || '';
      const callEvent = vm.conversionCallLengthEventMap[conversionSettings.conversionArgs.startTimerEvent];
      return `${callEvent} | ${callLength}`;
    }

    function editCallRoute (callRoute) {
      vm.activeActionRouteId = false;
      vm.selectedTarget = callRoute.callTarget || callRoute.callTargetGroup || callRoute.callPingTree;
      vm.currentRoute = angular.copy(callRoute);
      vm.currentRoute.callConversion = callRoute.conversionSettings[0];
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/new-target-route.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'xl'
      });
    }

    function createUpdateRoute() {
      return callRouteService.updateCallRoute(
        accountsService.currentAccountId,
        vm.currentRoute
      )
        .then(function () {
          vm.onUpdate({
            routeContainer: vm.routeContainer
          });
          cancelModal();
        })
        .catch(utils.errorHandler);
    }

    function cancelModal() {
      vm.currentRoute = {};
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function activateRouteActions(callRouteId) {
      vm.activeActionRouteId = vm.activeActionRouteId == callRouteId ? false : callRouteId;
    }

    function _loadIsRPC() {
      vm.isRPC = vm.routeType === 'RPC' || (vm.routeContainer && vm.routeContainer.routingType === 'RPC');
    }

    function _deleteRoute(callRouteId) {
      if (vm.routeContainerType === 'callPlan') {
        return callPlanService.deleteRoute(
          accountsService.currentAccountId,
          vm.routeContainer.id,
          callRouteId);
      } else {
        return campaignServiceNew.deleteRoute(
          accountsService.currentAccountId,
          vm.routeContainer.id,
          callRouteId);
      }
    }

    function _loadConversionSettings() {
      return infoService.getConversionSettings()
        .then(function (response) {
          vm.conversionSettings = response.data;
          angular.forEach(vm.conversionSettings, function (value){
            vm.conversionSettingsMap[value.conversionType] = value;
          });
        })
        .catch(utils.errorHandler);
    }

    // For now just update the status of Targets (i.e. targetGroups only
    // display enable/disable status and ring tree doesn't display anything at all)
    function _updateRouteStatus() {
      if (vm.routeContainer && typeof vm.routeContainer.routes !== 'undefined' && vm.routeContainer.routes.length > 0) {
        const targetsInRoutes = {};
        for (let i = 0; i < vm.routeContainer.routes.length; i++) {
          const route = vm.routeContainer.routes[i];
          if (route.callTarget && route.callTarget.id) {
            targetsInRoutes[route.callTarget.id] = route;
          }
        }
        if (Object.getOwnPropertyNames(targetsInRoutes).length > 0) {
          // Definitely not ideal. We need to implement caching in the service
          // even if it's only for a few seconds.
          targetService.getTargets(accountsService.currentAccountId, true)
            .then(function (targets) {
              for (let i = 0; i < targets.length; i++) {
                const t = targets[i],
                  r = targetsInRoutes[t.id];
                if (r && r.callTarget) {
                  r.callTarget = t;
                }
              }
            })
            .catch(utils.errorHandler);
        }
      }
    }

    // Check if target groups exist in the routes
    function _checkTargetGroups() {
      if (vm.routeContainer && typeof vm.routeContainer.routes !== 'undefined' && vm.routeContainer.routes.length > 0) {
        for (let i = 0; i < vm.routeContainer.routes.length; i++) {
          const route = vm.routeContainer.routes[i];
          if (route.callTargetGroup) {
            vm.hasTargetGroups = true;
            break;
          }
          vm.hasTargetGroups = false;
        }
      } else {
        vm.hasTargetGroups = false;
      }
    }
  }
})();
